<div class="app-dialog">
  <div class="app-dialog__heading">
    <button mat-icon-button type="button" class="usage-dialog-close" (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
    <div class="app-dialog__heading-copy">
      <span class="app-dialog__eyebrow">Account</span>
      <div class="app-dialog__title-row">
        <div class="app-dialog__title-copy">
          <h2 mat-dialog-title class="app-dialog__title">Plan Details</h2>
          <p>Review your current plan usage and limits.</p>
        </div>
      </div>
    </div>
  </div>

  <mat-dialog-content class="app-dialog__content">
    <div *ngIf="loading" class="loading-state">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div *ngIf="error && !loading" class="error-state">
      <mat-icon svgIcon="error_outline"></mat-icon>
      <p>{{ error }}</p>
    </div>

    <div *ngIf="!loading && usage" class="usage-list">
      <div class="usage-row">
        <div class="label">Storage</div>
        <div class="value">{{ usage.storage.usedMB }} MB / {{ usage.storage.maxMB }} MB</div>
      </div>

      <div class="usage-row">
        <div class="label">Max Rows Per File</div>
        <div class="value">{{ getValueOrUnlimited(usage.maxRowsPerFile) }}</div>
      </div>

      <div class="usage-row">
        <div class="label">Rate Limit</div>
        <div class="value">{{ usage.rateLimit.processed }} / {{ getValueOrUnlimited(usage.rateLimit.max) }}</div>
      </div>

      <div class="usage-row">
        <div class="label">Data Sources</div>
        <div class="value">{{ usage.dataSources.used }} / {{ getValueOrUnlimited(usage.dataSources.max) }}</div>
      </div>

      <div class="usage-row">
        <div class="label">Workflows</div>
        <div class="value">{{ usage.workflows.used }} / {{ getValueOrUnlimited(usage.workflows.max) }}</div>
      </div>

      <div class="usage-row">
        <div class="label">Profiles Used</div>
        <div class="value">{{ usage.profilesUsed }}</div>
      </div>

      <div class="usage-row">
        <div class="label">Anomalies Used</div>
        <div class="value">{{ usage.anomaliesUsed }}</div>
      </div>
    </div>
  </mat-dialog-content>

  <!-- <mat-dialog-actions class="app-dialog__actions" align="end">
    <button mat-button type="button" (click)="close()">Close</button>
  </mat-dialog-actions> -->
</div>
